(function () {
  'use strict';

  /* ------------------------------------------------------------------
     HELPER: focus trap for accessibility
  ------------------------------------------------------------------ */
  function trapFocus(element) {
    var focusable = element.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    function onKeyDown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    }

    element.addEventListener('keydown', onKeyDown);
    return function () { element.removeEventListener('keydown', onKeyDown); };
  }

  /* ------------------------------------------------------------------
     MOBILE NAV DRAWER
  ------------------------------------------------------------------ */
  var drawer        = document.getElementById('custom-mobile-drawer');
  var drawerOverlay = document.getElementById('custom-drawer-overlay');
  var drawerClose   = document.getElementById('custom-drawer-close');
  var menuToggles   = document.querySelectorAll(
    '#custom-menu-toggle-home, #custom-menu-toggle-inner'
  );
  var removeTrapFocus = null;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
    drawer.removeAttribute('aria-hidden');

    menuToggles.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });

    setTimeout(function () {
      var firstFocusable = drawer.querySelector('a[href], button:not([disabled])');
      if (firstFocusable) firstFocusable.focus();
      removeTrapFocus = trapFocus(drawer);
    }, 50);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    drawer.setAttribute('aria-hidden', 'true');

    menuToggles.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus();
      removeTrapFocus = null;
    }

    if (menuToggles[0]) menuToggles[0].focus();
  }

  menuToggles.forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });

  if (drawerClose)   drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  /* ------------------------------------------------------------------
     SEARCH MODAL
  ------------------------------------------------------------------ */
  var searchModal    = document.getElementById('custom-search-modal');
  var searchOverlay  = document.getElementById('custom-search-overlay');
  var searchClose    = document.getElementById('custom-search-close');
  var searchInput    = document.getElementById('custom-search-input');
  var searchTriggers = document.querySelectorAll('[data-custom-search-trigger]');
  var removeSearchTrap = null;

  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    document.body.classList.add('drawer-open');

    setTimeout(function () {
      if (searchInput) searchInput.focus();
      removeSearchTrap = trapFocus(searchModal);
    }, 100);
  }

  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-open');
    document.body.classList.remove('drawer-open');

    if (typeof removeSearchTrap === 'function') {
      removeSearchTrap();
      removeSearchTrap = null;
    }
  }

  searchTriggers.forEach(function (btn) {
    btn.addEventListener('click', openSearch);
  });

  if (searchClose)   searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

  /* ESC key — closes any open modal */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer      && drawer.classList.contains('is-open'))      closeDrawer();
    if (searchModal && searchModal.classList.contains('is-open')) closeSearch();
  });

  /* ------------------------------------------------------------------
     CART COUNT  (legacy badge updater — kept for compatibility)
  ------------------------------------------------------------------ */
  function updateCartCount(count) {
    var badges    = document.querySelectorAll('.custom-cart-count');
    var cartLinks = document.querySelectorAll(
      '#cart-icon-bubble, #cart-icon-bubble-inner, ' +
      '#cart-icon-bubble-mobile-home, #cart-icon-bubble-mobile-inner'
    );

    if (count > 0) {
      var displayCount = count < 100 ? count : '99+';

      badges.forEach(function (badge) {
        badge.textContent    = displayCount;
        badge.style.display  = 'flex';
      });

      cartLinks.forEach(function (link) {
        if (!link.querySelector('.custom-cart-count')) {
          var span = document.createElement('span');
          span.className          = 'custom-cart-count';
          span.setAttribute('aria-hidden', 'true');
          span.textContent        = displayCount;
          link.appendChild(span);
        }
      });
    } else {
      badges.forEach(function (badge) { badge.remove(); });
    }

    var drawerCartLink = document.getElementById('drawer-cart-link');
    if (drawerCartLink) {
      drawerCartLink.childNodes.forEach(function (node) {
        if (node.nodeType === 3) {
          node.textContent = count > 0 ? ' Cart (' + count + ')' : ' Cart';
        }
      });
    }
  }

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.cartCount !== 'undefined') {
      updateCartCount(e.detail.cartCount);
    }
  });

  document.addEventListener('cart-notification:open', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  });

  /* Refresh badge every 30 seconds */
  setInterval(function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }, 30000);

})(); /* ← END of main IIFE */


/* ====================================================================
   GLOBAL PRODUCT PAGE FUNCTIONS
==================================================================== */
window.changeQuantity = function (delta) {
  var qtyInput   = document.getElementById('quantity-input');
  var qtyDisplay = document.getElementById('quantity-display');
  if (!qtyInput || !qtyDisplay) return;
  var currentQuantity = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
  qtyDisplay.textContent = currentQuantity;
  qtyInput.value         = currentQuantity;
};

window.initVariantLabels = function () {
  document.querySelectorAll('.variant-option-label').forEach(function (label) {
    var input = document.getElementById(label.getAttribute('for'));

    label.addEventListener('click', function () {
      this.parentElement.querySelectorAll('.variant-option-label').forEach(function (l) {
        l.style.backgroundColor = 'transparent';
        l.style.borderColor     = 'var(--c-outline)';
        l.style.color           = 'var(--c-text-main)';
      });
      this.style.backgroundColor = 'var(--c-primary)';
      this.style.borderColor     = 'var(--c-primary)';
      this.style.color           = 'var(--c-white)';
    });

    if (input && input.checked) {
      label.style.backgroundColor = 'var(--c-primary)';
      label.style.borderColor     = 'var(--c-primary)';
      label.style.color           = 'var(--c-white)';
    }
  });
};


/* ====================================================================
   GIFT BOX CART CLASS
   Handles adding bundles (parent box + child products) to the cart
==================================================================== */
class GiftBoxCart {

  /* Generate a unique ID for this bundle session */
  generateBundleId() {
    const timestamp = Math.floor(Date.now() / 1000);
    const random    = Math.random().toString(36).substring(2, 6);
    return 'gift_box_' + timestamp + '_' + random;
  }

  /* Add the gift box (parent) + selected items (children) in one call */
  async addGiftBoxToCart(boxProduct, selectedProducts) {
    const bundleId = this.generateBundleId();
    const items    = [];

    /* Parent — the gift box product itself */
    items.push({
      id:         boxProduct.variantId,
      quantity:   1,
      properties: {
        '_bundle_id':          bundleId,
        '_is_bundle_parent':   'true',
        '_bundle_item_count':  selectedProducts.length.toString()
      }
    });

    /* Children — every item the customer chose */
    selectedProducts.forEach(function (product) {
      items.push({
        id:         product.variantId,
        quantity:   1,
        properties: {
          '_bundle_id':             bundleId,
          '_is_bundle_child':       'true',
          '_bundle_parent_title':   boxProduct.title,
          '_bundle_collection':     product.collectionHandle
        }
      });
    });

    /* Single POST — adds all items at once */
    const response = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ items })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Cart add failed:', errorText);
      throw new Error('Cart add failed: ' + response.status);
    }

    return response.json();
  }

  /* Remove every item that shares a bundle ID */
  async removeBundleFromCart(bundleId) {
    const cartResponse = await fetch('/cart.js');
    const cart         = await cartResponse.json();

    const updates = {};
    cart.items.forEach(function (item) {
      if (item.properties && item.properties['_bundle_id'] === bundleId) {
        updates[item.key] = 0;
      }
    });

    const response = await fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ updates })
    });

    return response.json();
  }
}

/* Make one shared instance available everywhere */
window.GiftBoxCart = new GiftBoxCart();




/* ====================================================================
   PRODUCT CARD — Quick "+" add-to-cart buttons
   Used in collection grids / featured product cards
==================================================================== */
/* Exposed globally so infinite scroll can bind quick-add on newly appended cards */
window.bindAjaxAddToCart = function (root) {
  (root || document).querySelectorAll('.ajax-add-to-cart-btn:not([data-qa-bound])').forEach(function (button) {
    button.setAttribute('data-qa-bound', '1');

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var btn       = this;
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      var original  = btn.innerHTML;

      if (!variantId) {
        console.error('ajax-add-to-cart-btn: missing data-variant-id');
        return;
      }

      btn.innerHTML = '…';
      btn.classList.add('is-loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method:      'POST',
        credentials: 'same-origin',
        headers:     { 'Content-Type': 'application/json' },
        body:        JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
          return r.json();
        })
        .then(function () {
          btn.innerHTML = '✓';
          btn.classList.remove('is-loading');

          /* Open the drawer cart */
          if (typeof DrawerCart !== 'undefined') {
            DrawerCart.open();
          }

          setTimeout(function () { btn.innerHTML = original; }, 2000);
        })
        .catch(function (err) {
          console.error(err);
          btn.innerHTML = original;
          btn.classList.remove('is-loading');
          alert('Could not add to cart. Please try again.');
        });
    });

  });
};

document.addEventListener('DOMContentLoaded', function () {
  window.bindAjaxAddToCart(document);
});

/* clark-asset-loader: resolves companion script URLs through the section
   rendering API. Thunder rewrites <script> tags, so deriving URLs from the
   DOM is unreliable; Liquid renders the exact CDN URL instead. */
(function () {
  function boot() {
    try { document.documentElement.setAttribute('data-clark-boot', 'ran'); } catch (e) {}
    if (document.querySelector('script[data-clark-booted]')) return;
    function injectSrc(url) {
      try { document.documentElement.setAttribute('data-clark-boot', 'inject:' + (url || 'empty').slice(-30)); } catch (e) {}
      if (!url || document.querySelector('script[src="' + url + '"]')) return;
      var e = document.createElement('script');
      e.src = url;
      e.setAttribute('data-clark-booted', '1');
      document.head.appendChild(e);
    }
    function injectFromDom() {
      /* Fallback: swap filename on any theme asset tag, keeping its ?v= cache key. */
      var a = document.querySelector('script[src*="/assets/"]');
      if (!a || !a.src) return;
      injectSrc(a.src.replace(/\/assets\/[^/?#]+(?=[?#]|$)/, '/assets/clark-cart-upsells.js'));
      injectSrc(a.src.replace(/\/assets\/[^/?#]+(?=[?#]|$)/, '/assets/infinite-scroll.js'));
    }
    fetch('/?sections=clark-upsells-loader&t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        var html = d && d['clark-upsells-loader'];
        if (!html) { injectFromDom(); return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var tags = tmp.querySelectorAll('script[data-clark-src]');
        if (!tags.length) { injectFromDom(); return; }
        Array.prototype.forEach.call(tags, function (tag) { injectSrc(tag.src); });
      })
      .catch(function () { try { document.documentElement.setAttribute('data-clark-boot', 'fetch-err'); } catch (e) {} injectFromDom(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
